export default values => {
    if (!Array.isArray(values) || !values.length) {
        return '-';
    }

    const mappedProductVariants = values
        .map(value => {
            const {
                attributes,
                product: { name },
                Order2ProductVariant: { quantity }
            } = value;

            const mappedAttributes = attributes
                .map(value => `${value.group.name}: ${value.value}`)
                .join(', ');

            return `${quantity} - ${name} - ${mappedAttributes}`;
        })
        .join('\n');

    return mappedProductVariants;
};
